import { render, staticRenderFns } from "./NgStorePickupOrders.vue?vue&type=template&id=2fac9bac"
import script from "./NgStorePickupOrders.vue?vue&type=script&lang=js"
export * from "./NgStorePickupOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports